exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content_img[data-v-5f3883a2]{padding-top:10px}.content_img img[data-v-5f3883a2]{max-width:140px;min-width:20px;max-height:140px;min-height:20px;cursor:pointer}\n", ""]);

// exports
